/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactWithUtterances } from './ContactWithUtterances.js';
import {
    ContactWithUtterancesFromJSON,
    ContactWithUtterancesFromJSONTyped,
    ContactWithUtterancesToJSON,
} from './ContactWithUtterances.js';

/**
 * 
 * @export
 * @interface ListScorecardContactsResponse
 */
export interface ListScorecardContactsResponse {
    /**
     * 
     * @type {Array<ContactWithUtterances>}
     * @memberof ListScorecardContactsResponse
     */
    data?: Array<ContactWithUtterances>;
    /**
     * 
     * @type {number}
     * @memberof ListScorecardContactsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ListScorecardContactsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ListScorecardContactsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ListScorecardContactsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ListScorecardContactsResponse interface.
 */
export function instanceOfListScorecardContactsResponse(value: object): boolean {
    return true;
}

export function ListScorecardContactsResponseFromJSON(json: any): ListScorecardContactsResponse {
    return ListScorecardContactsResponseFromJSONTyped(json, false);
}

export function ListScorecardContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListScorecardContactsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ContactWithUtterancesFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ListScorecardContactsResponseToJSON(value?: ListScorecardContactsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ContactWithUtterancesToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

